import React from 'react'
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, message, AutoComplete, Modal } from 'antd'
import { reqHaplotypeBlockids, reqHaplotypeChr, reqSearchHaplotype } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchHaplotype extends React.Component {
    state = {
        population: '',
        blockid: '',
        snpid: '',
        loc_chr: '',
        chr_options: [],
        loc_start: '',
        loc_end: '',
        searchResult: [],
        disabled: false,
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true,
        },
        visible: false,
        modal_snpids: '',
    }
    formRef = React.createRef()

    onFinish = async (values) => {
        const { population, blockid, snpid, loc_chr, loc_start, loc_end } = values
        this.setState({
            disabled: true,
            loading: true
        })

        const param = {
            snp_ids: snpid,
            population: population,
            block_id: blockid,
            chr: loc_chr,
            pos_start__gte: loc_start,
            pos_end__lt: loc_end,
            snp_ids: snpid,
            page: 1
        }

        let table_title = ''
        const searchResult = await reqSearchHaplotype(param)
        if (searchResult.code === 0) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                population: population,
                blockid: blockid,
                snpid: snpid,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
    }

    onPopulationChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            blockid: '',
            snpid: '',
            loc_chr: '',
            loc_start: '',
            loc_end: ''
        })
        this.setState({
            chr_options: []
        })

        if (val) {
            let chr_options = []
            const chr_results = await reqHaplotypeChr()
            if (chr_results.code === 0) {
                let chr = chr_results.data
                for (let v of chr) {
                    v['value'] = v['chr']
                    v['label'] = v['chr']
                }
                chr_options = chr
            } else {
                message.error('Request failed. ' + chr_results.message)
            }
            
            this.setState({
                population: val,
                chr_options: chr_options
            })
        }

        this.setState({
            population: val
        })
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { population, blockid, snpid, loc_chr, loc_start, loc_end } = this.state
        const { current } = pagination

        const param = {
            snp_ids: snpid,
            population: population,
            block_id: blockid,
            chr: loc_chr,
            pos_start__gte: loc_start,
            pos_end__lt: loc_end,
            page: current
        }

        const searchResult = await reqSearchHaplotype(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    async componentDidMount() {
        let chr_options = []
        
        const chr_results = await reqHaplotypeChr()
        if (chr_results.code === 0) {
            let chr = chr_results.data
            for (let v of chr) {
                v['value'] = v['chr']
                v['label'] = v['chr']
            }
            chr_options = chr
        } else {
            message.error('Request failed. ' + chr_results.message)
        }

        this.setState({
            chr_options: chr_options
        })
    }

    render() {
        const { chr_options, searchResult, title, loading, has_data, disabled, pagination, modal_snpids } = this.state
        
        const layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 4, span: 12 },
        }

        const columns = [
            {
                title: 'Block ID',
                dataIndex: 'block_id',
            },
            {
                title: 'SNP Tag',
                dataIndex: 'tag_snp',
            },
            {
                title: 'Chr',
                dataIndex: 'chr',
            },
            {
                title: 'Start',
                dataIndex: 'pos_start',
                width: 120,
            },
            {
                title: 'End',
                dataIndex: 'pos_end',
                width: 120,
            },
            {
                title: 'Length(kb)',
                dataIndex: 'length_kb',
                width: 100,
            },
            {
                title: 'SNP No',
                dataIndex: 'snps_num',
                width: 100,
            },
            {
                title: 'SNP IDs',
                dataIndex: 'snp_ids',
                width: 100,
                render: (item) => {
                    let snpids = ''
                    let snpids_arr = item.split('|')
                    snpids = snpids_arr.map((item) => {
                        return <p key={item}>{item}</p>
                    })
                    
                    const onClick = () => {
                        this.setState({
                            visible: true,
                            modal_snpids: snpids
                        })
                    }
                    
                    const show_snpids_btn = <Button type="primary" size="small" onClick={onClick}>SNP IDs</Button>
                    
                    return show_snpids_btn
                }
            },
            {
                title: 'Action',
                dataIndex: '',
                width: 160,
                key: 'operation',
                render: (item) => {
                    const gwasviz_link = `/tool/gwas_single_trait/${item.population}/${item.chr}/${item.posi-50000}/${item.posi+50000}`
                    return (<Button type="primary" size="small" disabled href={ gwasviz_link } target="_blank" className="gwasviz-action">Jbrowse Visualizer</Button>)
                }
            },
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['block_id'] + '-' + v['tag_snp']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} name="search-haplotype" ref={this.formRef} className="search-haplotype-form" onFinish={this.onFinish}>
                    <Paragraph>
                        Search for haplotype blocks and tag SNPs by block and SNP ids, and physical regions based on Cotton Genome Assembly. Each record has linked to its position on Jbrowse .
                        Learn more about the analysis details for this data at Cotton Genetic Variations:Haplotypes.
                    </Paragraph>
                    <Form.Item name="population" label="Population" rules={[{ required: true }]}>
                            <Select placeholder="Select population" showArrow allowClear onChange={this.onPopulationChange}>
                                <Option value="arahy.Tifrunner(haplotype)">arahy.Tifrunner</Option>
                            </Select>
                        </Form.Item>
                    <Form.Item name="blockid" label="Block ID">
                        <Input />
                    </Form.Item>
                    <Form.Item name="snpid" label="SNP ID">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Genome Location" wrapperCol={{span: 18}}>
                        <Row>
                            <Col>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr" label="chr">
                                        <AutoComplete 
                                            allowClear
                                            style={{width: 250}}
                                            placeholder="chr"
                                            options={chr_options}
                                            filterOption={(inputValue, option) =>
                                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                        />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location start position" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location end position" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
                <Modal
                    title="SNP IDs"
                    centered
                    visible={this.state.visible}
                    onOk={() => this.setState({visible: false})}
                    onCancel={() => this.setState({visible: false})}
                    width={1000}
                    height={1000}
                    style={{overflow: 'auto'}}
                >
                    { modal_snpids }
                </Modal>
            </React.Fragment>
        )
    }
}

export default SearchHaplotype